// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2QFdL","inner":"Form_inner__1Eof_","range":"Form_range__2BrBf","name":"Form_name__3iKsZ","actions":"Form_actions__3LkSx"};